<template>
  <div class='partner-home'>
    <Announcement @setMainContent="setMainContent"></Announcement>
    <Quick @itemClick="itemClick" :cmsConfig="cmsConfig"/>
    <ModalManage @menuChange="menuChange" />
    <div class="row-container gap-m-t">
      <div class="gap-m-r" style="flex: 1.6;">
        <todo-reminder />
      </div>
      <div class="col-1" style="flex: 1;">
        <partner-info />
      </div>
    </div>
    <div class="row-container gap-m-t">
      <div class="col-1">
        <data-kanban />
      </div>
    </div>
    <div class="row-container gap-m-t" v-if="cmsConfig.banner && cmsConfig.banner.length > 0">
      <Banner />
    </div>
    <div class="row-container gap-m-t">
      <div class="gap-m-r" style="flex: 1.3">
        <MarketingTools panelPaddingBottom="10px" />
      </div>
      <div class="col-1">
        <biz-school />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Quick from './components/quick'
import ModalManage from '../common/modal-manage'
import Announcement from '../common/announceInfo/newAnnounce'
import Banner from '../common/banner'
import MarketingTools from '../common/marketingTool'
import School from '../common/school'
import Todo from './components/todo'
import PartnerHome from './components/partnerInfo'
import DataKanban from './components/dataKanban'

export default {
  name: "home-partner",
  methods: {
    setMainContent(component) {
      this.$emit('setMainContent', component)
    },
    itemClick (link) {
      this.$emit('itemClick', link)
    },
    menuChange(item) {
      this.$emit('menuChange', item)
    },
  },
  computed: {
    ...mapState(['cmsConfig']),
  },
  components: {
    Announcement,
    Quick,
    ModalManage,
    Banner,
    MarketingTools,
    [School.name]: School,
    [Todo.name]: Todo,
    [PartnerHome.name]: PartnerHome,
    [DataKanban.name]: DataKanban,
  }
}
</script>
<style lang="scss" scoped>
.partner-home .common-panel-container {
  height: 100%;
}
.key-btn-container {
  a, span {
    color: #1C7AE5;
    cursor: pointer;
    margin-left: 20px;
  }
}
.row-container {
  display: flex;
  .col-1 {
    flex: 1;
    width: 100%;
  }
}
.gap-m-r {
  margin-right: 15px;
}
.gap-m-t {
  margin-top: 15px;
}
</style>
